import { PaymentProviderType } from "@redotech/redo-billing-common/billing-engine-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getPreferredPaymentProvider = {
  name: "getPreferredPaymentProvider" as const,
  input: z.object({}),
  output: createEnum(PaymentProviderType),
};
